import { LlmModel, type LlmModelSelectDto } from '@@types/api.types';

export function isStructuredOutputModelSelectable(model: LlmModelSelectDto): boolean {
  return !model.archived && model.hasStructuredOutputs === true && model.value !== LlmModel.OpenrouterAuto;
}
